import useSearchData from './useSearchData';

export default useSearchData;
